module.exports = __webpack_public_path__ + "img/economy.d07a6e49.png";